<template>
    <div class="mainbody modulewrap">
        <div class="banner">
            <div class="bannerimgbg" :style="{backgroundImage:'url('+pageinfo.banner+')'}"></div>
            <div class="bannertitle">
                <div class="main"><span>-{{pageinfo.title_en}}-</span></div>
                <div class="sub"><span>{{pageinfo.title}}</span></div>
            </div>
        </div>
        <div class="pagemain realwrap">
            <div class="pagenews">
                <div class="info">
                    <div class="title">{{$common.langinfo(newsdetail.title,newsdetail.title_en)}}<br /><span class="sub">{{$common.dicword('publishdate',true)+$common.basic.dateformat(newsdetail.datepublish)}}</span></div>
                    <div class="content editor">
                        <span v-html="$common.langinfo(newsdetail.content,newsdetail.content_en)"></span>
                    </div>
                </div>
                <div class="top">
                    <div class="titlewrap"><div class="title"><span class="t">{{$common.dicword('recommendnews')}}</span><span class="m"><router-link :to="pageinfo.alias=='tea_news_2'?'/news/list':'/news'">{{$common.dicword('all')}}{{$common.langinfo(pageinfo.title,pageinfo.title_en)}}</router-link></span></div></div>
                    <ul v-for="item in newstoplist" :key="item.id">
                        <li class="newscover"><fflink linktype="image" :info="item"></fflink></li>
                        <li class="newssimple">
                            <dl>
                                <dd class="a"><fflink :info="item"></fflink></dd>
                                <dd class="b">{{$common.basic.dateformat(item.datepublish)}}</dd>
                                <dd class="d"><fflink linktype="btn" :info="item"></fflink></dd>
                            </dl>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'newsdetail',
        data() {
            return {
                res: {},
                pageinfo: {},
                newstoplist: [],
                newsdetail: {},
            };
        },
        methods: {
            getnewsdetail: function (id) {
                this.$common.fetch({ 'act': 'tc_newsdetail', 'exts': 'id=' + id }, res => {
                    if (res.infodatanews.id >= 0) {
                        this.pageinfo = res.infodatanewscatalog;
                        this.newsdetail = res.infodatanews;
                        this.$common.each(res.infodatanewstop, (item) => {
                            item.x_url = res.infodatanewscatalog.url + '/' + item.id;
                            item.x_len = 26;
                            item.cover = item.imgs;

                            item.x_btn = this.$common.dicword('viewdetail') + '>>';
                        });
                        this.newstoplist = res.infodatanewstop;
                        this.res = res;
                    }
                    else {
                        //this.getnewslist();
                    }
                });
            }
        },
        mounted() {

            let id = this.$common.basic.chstr2int(this.$route.params.id);
            if (id > 0) {
                this.getnewsdetail(id);
            }
            else {
                this.$router.replace('/news/list');
            }

        }
    }
</script>
